import { render, staticRenderFns } from "./ProposalSliderImage.vue?vue&type=template&id=07230b1f"
import script from "./ProposalSliderImage.vue?vue&type=script&lang=js"
export * from "./ProposalSliderImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports